/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { ReportSource } from "../models/report-source";
import { ReportEmbeddedType } from "../models/report-embedded-type";
import { ReportEmbeddedTypeEx } from "../models/report-embedded-type-ex";
import { ReportStandardType } from "../models/report-standard-type";
import { ReportStandardTypeEx } from "../models/report-standard-type-ex";
import { ReportSubscriptionType } from "../models/report-subscription-type";
import { CreateReportSubscriptionType } from "../models/create-report-subscription-type";
import { UpdateReportSubscriptioinType } from "../models/update-report-subscriptioin-type";
import { ReportSubscriptionContent } from "../models/report-subscription-content";
import { ReportSubscriptionLevel } from "../models/report-subscription-level";
import { ReportSubscriptionLevelEx } from "../models/report-subscription-level-ex";
import { ReportSubscriptionPrice } from "../models/report-subscription-price";
import { ReportSubscriptionPriceEx } from "../models/report-subscription-price-ex";
import { ReportStandardLayoutEx } from "../models/report-standard-layout-ex";
import { ReportExport } from "../models/report-export";
import { ReportEmbeddedExport } from "../models/report-embedded-export";
import { EditEmbeddedReportExportLayoutData } from "../models/edit-embedded-report-export-layout-data";
import { ReportExportUserState } from "../models/report-export-user-state";
import { EmbedReportDetails } from "../models/embed-report-details";
import { StandardReportDetails } from "../models/standard-report-details";
import { LogWidgetUsage } from "../models/log-widget-usage";
@Injectable({
  providedIn: "root",
})
class ReportExportService extends __BaseService {
  static readonly reportExportCreateReportSourcePath =
    "/api/ReportExport/CreateReportSource";
  static readonly reportExportUpdateReportSourcePath =
    "/api/ReportExport/UpdateReportSource";
  static readonly reportExportDeleteReportSourcePath =
    "/api/ReportExport/DeleteReportSource";
  static readonly reportExportGetReportSourcesPath =
    "/api/ReportExport/GetReportSources";
  static readonly reportExportCreateReportEmbeddedTypePath =
    "/api/ReportExport/CreateReportEmbeddedType";
  static readonly reportExportUpdateReportEmbeddedTypePath =
    "/api/ReportExport/UpdateReportEmbeddedType";
  static readonly reportExportDeleteReportEmbeddedTypePath =
    "/api/ReportExport/DeleteReportEmbeddedType";
  static readonly reportExportGetReportEmbeddedTypesByReportSourcePath =
    "/api/ReportExport/GetReportEmbeddedTypesByReportSource";
  static readonly reportExportGetReportEmbeddedTypesPath =
    "/api/ReportExport/GetReportEmbeddedTypes";
  static readonly reportExportCreateReportStandardTypePath =
    "/api/ReportExport/CreateReportStandardType";
  static readonly reportExportUpdateReportStandardTypePath =
    "/api/ReportExport/UpdateReportStandardType";
  static readonly reportExportDeleteReportStandardTypePath =
    "/api/ReportExport/DeleteReportStandardType";
  static readonly reportExportGetReportStandardTypesByReportSourcePath =
    "/api/ReportExport/GetReportStandardTypesByReportSource";
  static readonly reportExportGetReportStandardTypesPath =
    "/api/ReportExport/GetReportStandardTypes";
  static readonly reportExportCreateReportSubscriptionTypePath =
    "/api/ReportExport/CreateReportSubscriptionType";
  static readonly reportExportUpdateReportSubscriptionTypePath =
    "/api/ReportExport/UpdateReportSubscriptionType";
  static readonly reportExportDeleteReportSubscriptionTypePath =
    "/api/ReportExport/DeleteReportSubscriptionType";
  static readonly reportExportGetReportSubscriptionTypesPath =
    "/api/ReportExport/GetReportSubscriptionTypes";
  static readonly reportExportGetReportSubscriptionContentPath =
    "/api/ReportExport/CreateReportSubscriptionContent";
  static readonly reportExportDeleteReportSubscriptionContentPath =
    "/api/ReportExport/DeleteReportSubscriptionContent";
  static readonly reportExportGetReportSubscriptionContentsBySubscriptionTypePath =
    "/api/ReportExport/GetReportSubscriptionContentsBySubscriptionType";
  static readonly reportExportGetReportSubscriptionContentsPath =
    "/api/ReportExport/GetReportSubscriptionContents";
  static readonly reportExportCreateReportSubscriptionLevelPath =
    "/api/ReportExport/CreateReportSubscriptionLevel";
  static readonly reportExportUpdateReportSubscriptionLevelPath =
    "/api/ReportExport/UpdateReportSubscriptionLevel";
  static readonly reportExportDeleteReportSubscriptionLevelPath =
    "/api/ReportExport/DeleteReportSubscriptionLevel";
  static readonly reportExportGetReportSubscriptionLevelsBySubscriptionTypePath =
    "/api/ReportExport/GetReportSubscriptionLevelsBySubscriptionType";
  static readonly reportExportGetReportSubscriptionLevelsPath =
    "/api/ReportExport/GetReportSubscriptionLevels";
  static readonly reportExportCreateReportSubscriptionPricePath =
    "/api/ReportExport/CreateReportSubscriptionPrice";
  static readonly reportExportUpdateReportSubscriptionPricePath =
    "/api/ReportExport/UpdateReportSubscriptionPrice";
  static readonly reportExportDeleteReportSubscriptionPricePath =
    "/api/ReportExport/DeleteReportSubscriptionPrice";
  static readonly reportExportGetReportSubscriptionPricesByReportTypeAndLevelPath =
    "/api/ReportExport/GetReportSubscriptionPricesByReportTypeAndLevel";
  static readonly reportExportGetReportSubscriptionPricesByReportTypePath =
    "/api/ReportExport/GetReportSubscriptionPricesByReportType";
  static readonly reportExportGetReportSubscriptionPricesPath =
    "/api/ReportExport/GetReportSubscriptionPrices";
  static readonly reportExportCreateReportStandardLayoutPath =
    "/api/ReportExport/CreateReportStandardLayout";
  static readonly reportExportUpdateReportStandardLayoutPath =
    "/api/ReportExport/UpdateReportStandardLayout";
  static readonly reportExportDeleteReportStandardLayoutPath =
    "/api/ReportExport/DeleteReportStandardLayout";
  static readonly reportExportGetReportStandardLayoutsByUserPath =
    "/api/ReportExport/GetReportStandardLayoutsByUser";
  static readonly reportExportGetReportStandardLayoutsBySubscriptionPath =
    "/api/ReportExport/GetReportStandardLayoutsBySubscription";
  static readonly reportExportGetReportStandardLayoutsByReportStandardTypePath =
    "/api/ReportExport/GetReportStandardLayoutsByReportStandardType";
  static readonly reportExportGetReportStandardLayoutsPath =
    "/api/ReportExport/GetReportStandardLayouts";
  static readonly reportExportReportExportRequestPath =
    "/api/ReportExport/ReportExportRequest";
  static readonly reportExportReportExportDeletePath =
    "/api/ReportExport/ReportExportDelete";
  static readonly reportExportReportExportExtendPath =
    "/api/ReportExport/ReportExportExtend";
  static readonly reportExportReportExportStatusUpdatePath =
    "/api/ReportExport/ReportExportStatusUpdate";
  static readonly reportExportGetReportExportsByUserPath =
    "/api/ReportExport/GetReportExportsByUser";
  static readonly reportExportGetReportExportsBySubscriptionPath =
    "/api/ReportExport/GetReportExportsBySubscription";
  static readonly reportExportGetReportExportByIdPath =
    "/api/ReportExport/GetReportExportById";
  static readonly reportExportGetReportExportDownloadUrlPath =
    "/api/ReportExport/GetReportExportDownloadUrl";
  static readonly reportExportCreateReportEmbeddedExportPath =
    "/api/ReportExport/CreateReportEmbeddedExport";
  static readonly reportExportUpdateReportEmbeddedExportPath =
    "/api/ReportExport/UpdateReportEmbeddedExport";
  static readonly reportExportGetReportEmbeddedExportsByUserIdPath =
    "/api/ReportExport/GetReportEmbeddedExportsByUserId";
  static readonly reportExportGetReportEmbeddedExportsBySubscriptionIdPath =
    "/api/ReportExport/GetReportEmbeddedExportsBySubscriptionId";
  static readonly reportExportReportEmbeddedExportDeletePath =
    "/api/ReportExport/DeleteReportEmbeddedExport";
  static readonly reportExportGetUserReportExportStatePath =
    "/api/ReportExport/GetUserReportExportState";
  static readonly reportExportGetUserReportExportStateByUserIdPath =
    "/api/ReportExport/GetUserReportExportStateByUserId";
  static readonly reportExportGetEmbedReportDetailsPath =
    "/api/ReportExport/GetEmbedReportDetails";
  static readonly reportExportGetStandardReportDetailsPath =
    "/api/ReportExport/GetStandardReportDetails";
  static readonly reportExportLogWidgetUsagePath =
    "/api/ReportExport/LogWidgetUsage";
  static readonly reportExportLogGatedWidgetUsagePath =
    "/api/ReportExport/LogGatedWidgetUsage";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportSourceParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `reportSource.ReportSourceId`:
   *
   * - `reportSource.PreFilterTitleAvailable`:
   *
   * - `reportSource.PreFilterRegionAvailable`:
   *
   * - `reportSource.PreFilterOccupationAvailable`:
   *
   * - `reportSource.PreFilterIndustryAvailable`:
   *
   * - `reportSource.PreFilterCompanyAvailable`:
   *
   * - `reportSource.PowerBIObjectName`:
   *
   * - `reportSource.Name`:
   *
   * - `reportSource.FileName`:
   *
   * - `reportSource.FileId`:
   *
   * - `reportSource.Description`:
   *
   * - `reportSource.Active`:
   *
   * - `PreFilterTitleAvailable`:
   *
   * - `PreFilterRegionAvailable`:
   *
   * - `PreFilterOccupationAvailable`:
   *
   * - `PreFilterIndustryAvailable`:
   *
   * - `PreFilterCompanyAvailable`:
   *
   * - `Active`:
   */
  reportExportCreateReportSourceResponse(
    params: ReportExportService.ReportExportCreateReportSourceParams
  ): __Observable<__StrictHttpResponse<ReportSource>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.upload != null) {
      __formData.append("upload", params.upload as string | Blob);
    }
    if (params.reportSourceReportSourceId != null) {
      __formData.append(
        "reportSource.ReportSourceId",
        JSON.stringify(params.reportSourceReportSourceId)
      );
    }
    if (params.reportSourcePreFilterTitleAvailable != null) {
      __formData.append(
        "reportSource.PreFilterTitleAvailable",
        JSON.stringify(params.reportSourcePreFilterTitleAvailable)
      );
    }
    if (params.reportSourcePreFilterRegionAvailable != null) {
      __formData.append(
        "reportSource.PreFilterRegionAvailable",
        JSON.stringify(params.reportSourcePreFilterRegionAvailable)
      );
    }
    if (params.reportSourcePreFilterOccupationAvailable != null) {
      __formData.append(
        "reportSource.PreFilterOccupationAvailable",
        JSON.stringify(params.reportSourcePreFilterOccupationAvailable)
      );
    }
    if (params.reportSourcePreFilterIndustryAvailable != null) {
      __formData.append(
        "reportSource.PreFilterIndustryAvailable",
        JSON.stringify(params.reportSourcePreFilterIndustryAvailable)
      );
    }
    if (params.reportSourcePreFilterCompanyAvailable != null) {
      __formData.append(
        "reportSource.PreFilterCompanyAvailable",
        JSON.stringify(params.reportSourcePreFilterCompanyAvailable)
      );
    }
    if (params.reportSourcePowerBIObjectName != null) {
      __formData.append(
        "reportSource.PowerBIObjectName",
        params.reportSourcePowerBIObjectName as string | Blob
      );
    }
    if (params.reportSourceName != null) {
      __formData.append(
        "reportSource.Name",
        params.reportSourceName as string | Blob
      );
    }
    if (params.reportSourceFileName != null) {
      __formData.append(
        "reportSource.FileName",
        params.reportSourceFileName as string | Blob
      );
    }
    if (params.reportSourceFileId != null) {
      __formData.append(
        "reportSource.FileId",
        params.reportSourceFileId as string | Blob
      );
    }
    if (params.reportSourceDescription != null) {
      __formData.append(
        "reportSource.Description",
        params.reportSourceDescription as string | Blob
      );
    }
    if (params.reportSourceActive != null) {
      __formData.append(
        "reportSource.Active",
        JSON.stringify(params.reportSourceActive)
      );
    }
    if (params.PreFilterTitleAvailable != null) {
      __formData.append(
        "PreFilterTitleAvailable",
        JSON.stringify(params.PreFilterTitleAvailable)
      );
    }
    if (params.PreFilterRegionAvailable != null) {
      __formData.append(
        "PreFilterRegionAvailable",
        JSON.stringify(params.PreFilterRegionAvailable)
      );
    }
    if (params.PreFilterOccupationAvailable != null) {
      __formData.append(
        "PreFilterOccupationAvailable",
        JSON.stringify(params.PreFilterOccupationAvailable)
      );
    }
    if (params.PreFilterIndustryAvailable != null) {
      __formData.append(
        "PreFilterIndustryAvailable",
        JSON.stringify(params.PreFilterIndustryAvailable)
      );
    }
    if (params.PreFilterCompanyAvailable != null) {
      __formData.append(
        "PreFilterCompanyAvailable",
        JSON.stringify(params.PreFilterCompanyAvailable)
      );
    }
    if (params.Active != null) {
      __formData.append("Active", JSON.stringify(params.Active));
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportSource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSource>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportSourceParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `reportSource.ReportSourceId`:
   *
   * - `reportSource.PreFilterTitleAvailable`:
   *
   * - `reportSource.PreFilterRegionAvailable`:
   *
   * - `reportSource.PreFilterOccupationAvailable`:
   *
   * - `reportSource.PreFilterIndustryAvailable`:
   *
   * - `reportSource.PreFilterCompanyAvailable`:
   *
   * - `reportSource.PowerBIObjectName`:
   *
   * - `reportSource.Name`:
   *
   * - `reportSource.FileName`:
   *
   * - `reportSource.FileId`:
   *
   * - `reportSource.Description`:
   *
   * - `reportSource.Active`:
   *
   * - `PreFilterTitleAvailable`:
   *
   * - `PreFilterRegionAvailable`:
   *
   * - `PreFilterOccupationAvailable`:
   *
   * - `PreFilterIndustryAvailable`:
   *
   * - `PreFilterCompanyAvailable`:
   *
   * - `Active`:
   */
  reportExportCreateReportSource(
    params: ReportExportService.ReportExportCreateReportSourceParams
  ): __Observable<ReportSource> {
    return this.reportExportCreateReportSourceResponse(params).pipe(
      __map((_r) => _r.body as ReportSource)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportSourceParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `reportSource.ReportSourceId`:
   *
   * - `reportSource.PreFilterTitleAvailable`:
   *
   * - `reportSource.PreFilterRegionAvailable`:
   *
   * - `reportSource.PreFilterOccupationAvailable`:
   *
   * - `reportSource.PreFilterIndustryAvailable`:
   *
   * - `reportSource.PreFilterCompanyAvailable`:
   *
   * - `reportSource.PowerBIObjectName`:
   *
   * - `reportSource.Name`:
   *
   * - `reportSource.FileName`:
   *
   * - `reportSource.FileId`:
   *
   * - `reportSource.Description`:
   *
   * - `reportSource.Active`:
   *
   * - `PreFilterTitleAvailable`:
   *
   * - `PreFilterRegionAvailable`:
   *
   * - `PreFilterOccupationAvailable`:
   *
   * - `PreFilterIndustryAvailable`:
   *
   * - `PreFilterCompanyAvailable`:
   *
   * - `Active`:
   */
  reportExportUpdateReportSourceResponse(
    params: ReportExportService.ReportExportUpdateReportSourceParams
  ): __Observable<__StrictHttpResponse<ReportSource>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.upload != null) {
      __formData.append("upload", params.upload as string | Blob);
    }
    if (params.reportSourceReportSourceId != null) {
      __formData.append(
        "reportSource.ReportSourceId",
        JSON.stringify(params.reportSourceReportSourceId)
      );
    }
    if (params.reportSourcePreFilterTitleAvailable != null) {
      __formData.append(
        "reportSource.PreFilterTitleAvailable",
        JSON.stringify(params.reportSourcePreFilterTitleAvailable)
      );
    }
    if (params.reportSourcePreFilterRegionAvailable != null) {
      __formData.append(
        "reportSource.PreFilterRegionAvailable",
        JSON.stringify(params.reportSourcePreFilterRegionAvailable)
      );
    }
    if (params.reportSourcePreFilterOccupationAvailable != null) {
      __formData.append(
        "reportSource.PreFilterOccupationAvailable",
        JSON.stringify(params.reportSourcePreFilterOccupationAvailable)
      );
    }
    if (params.reportSourcePreFilterIndustryAvailable != null) {
      __formData.append(
        "reportSource.PreFilterIndustryAvailable",
        JSON.stringify(params.reportSourcePreFilterIndustryAvailable)
      );
    }
    if (params.reportSourcePreFilterCompanyAvailable != null) {
      __formData.append(
        "reportSource.PreFilterCompanyAvailable",
        JSON.stringify(params.reportSourcePreFilterCompanyAvailable)
      );
    }
    if (params.reportSourcePowerBIObjectName != null) {
      __formData.append(
        "reportSource.PowerBIObjectName",
        params.reportSourcePowerBIObjectName as string | Blob
      );
    }
    if (params.reportSourceName != null) {
      __formData.append(
        "reportSource.Name",
        params.reportSourceName as string | Blob
      );
    }
    if (params.reportSourceFileName != null) {
      __formData.append(
        "reportSource.FileName",
        params.reportSourceFileName as string | Blob
      );
    }
    if (params.reportSourceFileId != null) {
      __formData.append(
        "reportSource.FileId",
        params.reportSourceFileId as string | Blob
      );
    }
    if (params.reportSourceDescription != null) {
      __formData.append(
        "reportSource.Description",
        params.reportSourceDescription as string | Blob
      );
    }
    if (params.reportSourceActive != null) {
      __formData.append(
        "reportSource.Active",
        JSON.stringify(params.reportSourceActive)
      );
    }
    if (params.PreFilterTitleAvailable != null) {
      __formData.append(
        "PreFilterTitleAvailable",
        JSON.stringify(params.PreFilterTitleAvailable)
      );
    }
    if (params.PreFilterRegionAvailable != null) {
      __formData.append(
        "PreFilterRegionAvailable",
        JSON.stringify(params.PreFilterRegionAvailable)
      );
    }
    if (params.PreFilterOccupationAvailable != null) {
      __formData.append(
        "PreFilterOccupationAvailable",
        JSON.stringify(params.PreFilterOccupationAvailable)
      );
    }
    if (params.PreFilterIndustryAvailable != null) {
      __formData.append(
        "PreFilterIndustryAvailable",
        JSON.stringify(params.PreFilterIndustryAvailable)
      );
    }
    if (params.PreFilterCompanyAvailable != null) {
      __formData.append(
        "PreFilterCompanyAvailable",
        JSON.stringify(params.PreFilterCompanyAvailable)
      );
    }
    if (params.Active != null) {
      __formData.append("Active", JSON.stringify(params.Active));
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportSource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSource>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportSourceParams` containing the following parameters:
   *
   * - `upload`:
   *
   * - `reportSource.ReportSourceId`:
   *
   * - `reportSource.PreFilterTitleAvailable`:
   *
   * - `reportSource.PreFilterRegionAvailable`:
   *
   * - `reportSource.PreFilterOccupationAvailable`:
   *
   * - `reportSource.PreFilterIndustryAvailable`:
   *
   * - `reportSource.PreFilterCompanyAvailable`:
   *
   * - `reportSource.PowerBIObjectName`:
   *
   * - `reportSource.Name`:
   *
   * - `reportSource.FileName`:
   *
   * - `reportSource.FileId`:
   *
   * - `reportSource.Description`:
   *
   * - `reportSource.Active`:
   *
   * - `PreFilterTitleAvailable`:
   *
   * - `PreFilterRegionAvailable`:
   *
   * - `PreFilterOccupationAvailable`:
   *
   * - `PreFilterIndustryAvailable`:
   *
   * - `PreFilterCompanyAvailable`:
   *
   * - `Active`:
   */
  reportExportUpdateReportSource(
    params: ReportExportService.ReportExportUpdateReportSourceParams
  ): __Observable<ReportSource> {
    return this.reportExportUpdateReportSourceResponse(params).pipe(
      __map((_r) => _r.body as ReportSource)
    );
  }

  /**
   * @param reportSourceId undefined
   */
  reportExportDeleteReportSourceResponse(
    reportSourceId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportSourceId != null)
      __params = __params.set("reportSourceId", reportSourceId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportSource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param reportSourceId undefined
   */
  reportExportDeleteReportSource(reportSourceId?: number): __Observable<Blob> {
    return this.reportExportDeleteReportSourceResponse(reportSourceId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  reportExportGetReportSourcesResponse(): __Observable<
    __StrictHttpResponse<Array<ReportSource>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportSources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSource>>;
      })
    );
  }
  reportExportGetReportSources(): __Observable<Array<ReportSource>> {
    return this.reportExportGetReportSourcesResponse().pipe(
      __map((_r) => _r.body as Array<ReportSource>)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportEmbeddedTypeParams` containing the following parameters:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportCreateReportEmbeddedTypeResponse(
    params: ReportExportService.ReportExportCreateReportEmbeddedTypeParams
  ): __Observable<__StrictHttpResponse<ReportEmbeddedType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSourceId != null)
      __params = __params.set(
        "reportSourceId",
        params.reportSourceId.toString()
      );
    if (params.reportPages != null)
      __params = __params.set("reportPages", params.reportPages.toString());
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.filterPage != null)
      __params = __params.set("filterPage", params.filterPage.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportEmbeddedType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportEmbeddedType>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportEmbeddedTypeParams` containing the following parameters:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportCreateReportEmbeddedType(
    params: ReportExportService.ReportExportCreateReportEmbeddedTypeParams
  ): __Observable<ReportEmbeddedType> {
    return this.reportExportCreateReportEmbeddedTypeResponse(params).pipe(
      __map((_r) => _r.body as ReportEmbeddedType)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportEmbeddedTypeParams` containing the following parameters:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `reportEmbeddedTypeId`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportUpdateReportEmbeddedTypeResponse(
    params: ReportExportService.ReportExportUpdateReportEmbeddedTypeParams
  ): __Observable<__StrictHttpResponse<ReportEmbeddedType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSourceId != null)
      __params = __params.set(
        "reportSourceId",
        params.reportSourceId.toString()
      );
    if (params.reportPages != null)
      __params = __params.set("reportPages", params.reportPages.toString());
    if (params.reportEmbeddedTypeId != null)
      __params = __params.set(
        "reportEmbeddedTypeId",
        params.reportEmbeddedTypeId.toString()
      );
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.filterPage != null)
      __params = __params.set("filterPage", params.filterPage.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportEmbeddedType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportEmbeddedType>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportEmbeddedTypeParams` containing the following parameters:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `reportEmbeddedTypeId`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportUpdateReportEmbeddedType(
    params: ReportExportService.ReportExportUpdateReportEmbeddedTypeParams
  ): __Observable<ReportEmbeddedType> {
    return this.reportExportUpdateReportEmbeddedTypeResponse(params).pipe(
      __map((_r) => _r.body as ReportEmbeddedType)
    );
  }

  /**
   * @param reportEmbeddedTypeId undefined
   */
  reportExportDeleteReportEmbeddedTypeResponse(
    reportEmbeddedTypeId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportEmbeddedTypeId != null)
      __params = __params.set(
        "reportEmbeddedTypeId",
        reportEmbeddedTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportEmbeddedType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param reportEmbeddedTypeId undefined
   */
  reportExportDeleteReportEmbeddedType(
    reportEmbeddedTypeId?: number
  ): __Observable<Blob> {
    return this.reportExportDeleteReportEmbeddedTypeResponse(
      reportEmbeddedTypeId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param reportSourceId undefined
   */
  reportExportGetReportEmbeddedTypesByReportSourceResponse(
    reportSourceId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportEmbeddedTypeEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportSourceId != null)
      __params = __params.set("reportSourceId", reportSourceId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportEmbeddedTypesByReportSource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportEmbeddedTypeEx>>;
      })
    );
  }
  /**
   * @param reportSourceId undefined
   */
  reportExportGetReportEmbeddedTypesByReportSource(
    reportSourceId?: number
  ): __Observable<Array<ReportEmbeddedTypeEx>> {
    return this.reportExportGetReportEmbeddedTypesByReportSourceResponse(
      reportSourceId
    ).pipe(__map((_r) => _r.body as Array<ReportEmbeddedTypeEx>));
  }
  reportExportGetReportEmbeddedTypesResponse(): __Observable<
    __StrictHttpResponse<Array<ReportEmbeddedTypeEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportEmbeddedTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportEmbeddedTypeEx>>;
      })
    );
  }
  reportExportGetReportEmbeddedTypes(): __Observable<
    Array<ReportEmbeddedTypeEx>
  > {
    return this.reportExportGetReportEmbeddedTypesResponse().pipe(
      __map((_r) => _r.body as Array<ReportEmbeddedTypeEx>)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportStandardTypeParams` containing the following parameters:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportCreateReportStandardTypeResponse(
    params: ReportExportService.ReportExportCreateReportStandardTypeParams
  ): __Observable<__StrictHttpResponse<ReportStandardType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSourceId != null)
      __params = __params.set(
        "reportSourceId",
        params.reportSourceId.toString()
      );
    if (params.reportPages != null)
      __params = __params.set("reportPages", params.reportPages.toString());
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.filterPage != null)
      __params = __params.set("filterPage", params.filterPage.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportStandardType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportStandardType>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportStandardTypeParams` containing the following parameters:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportCreateReportStandardType(
    params: ReportExportService.ReportExportCreateReportStandardTypeParams
  ): __Observable<ReportStandardType> {
    return this.reportExportCreateReportStandardTypeResponse(params).pipe(
      __map((_r) => _r.body as ReportStandardType)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportStandardTypeParams` containing the following parameters:
   *
   * - `reportStandardTypeId`:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportUpdateReportStandardTypeResponse(
    params: ReportExportService.ReportExportUpdateReportStandardTypeParams
  ): __Observable<__StrictHttpResponse<ReportStandardType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportStandardTypeId != null)
      __params = __params.set(
        "reportStandardTypeId",
        params.reportStandardTypeId.toString()
      );
    if (params.reportSourceId != null)
      __params = __params.set(
        "reportSourceId",
        params.reportSourceId.toString()
      );
    if (params.reportPages != null)
      __params = __params.set("reportPages", params.reportPages.toString());
    if (params.name != null)
      __params = __params.set("name", params.name.toString());
    if (params.filterPage != null)
      __params = __params.set("filterPage", params.filterPage.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportStandardType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportStandardType>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportStandardTypeParams` containing the following parameters:
   *
   * - `reportStandardTypeId`:
   *
   * - `reportSourceId`:
   *
   * - `reportPages`:
   *
   * - `name`:
   *
   * - `filterPage`:
   */
  reportExportUpdateReportStandardType(
    params: ReportExportService.ReportExportUpdateReportStandardTypeParams
  ): __Observable<ReportStandardType> {
    return this.reportExportUpdateReportStandardTypeResponse(params).pipe(
      __map((_r) => _r.body as ReportStandardType)
    );
  }

  /**
   * @param reportStandardTypeId undefined
   */
  reportExportDeleteReportStandardTypeResponse(
    reportStandardTypeId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportStandardTypeId != null)
      __params = __params.set(
        "reportStandardTypeId",
        reportStandardTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportStandardType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param reportStandardTypeId undefined
   */
  reportExportDeleteReportStandardType(
    reportStandardTypeId?: number
  ): __Observable<Blob> {
    return this.reportExportDeleteReportStandardTypeResponse(
      reportStandardTypeId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param reportSourceId undefined
   */
  reportExportGetReportStandardTypesByReportSourceResponse(
    reportSourceId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportStandardTypeEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportSourceId != null)
      __params = __params.set("reportSourceId", reportSourceId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportStandardTypesByReportSource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportStandardTypeEx>>;
      })
    );
  }
  /**
   * @param reportSourceId undefined
   */
  reportExportGetReportStandardTypesByReportSource(
    reportSourceId?: number
  ): __Observable<Array<ReportStandardTypeEx>> {
    return this.reportExportGetReportStandardTypesByReportSourceResponse(
      reportSourceId
    ).pipe(__map((_r) => _r.body as Array<ReportStandardTypeEx>));
  }
  reportExportGetReportStandardTypesResponse(): __Observable<
    __StrictHttpResponse<Array<ReportStandardTypeEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportStandardTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportStandardTypeEx>>;
      })
    );
  }
  reportExportGetReportStandardTypes(): __Observable<
    Array<ReportStandardTypeEx>
  > {
    return this.reportExportGetReportStandardTypesResponse().pipe(
      __map((_r) => _r.body as Array<ReportStandardTypeEx>)
    );
  }

  /**
   * @param request undefined
   */
  reportExportCreateReportSubscriptionTypeResponse(
    request: CreateReportSubscriptionType
  ): __Observable<__StrictHttpResponse<ReportSubscriptionType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportSubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionType>;
      })
    );
  }
  /**
   * @param request undefined
   */
  reportExportCreateReportSubscriptionType(
    request: CreateReportSubscriptionType
  ): __Observable<ReportSubscriptionType> {
    return this.reportExportCreateReportSubscriptionTypeResponse(request).pipe(
      __map((_r) => _r.body as ReportSubscriptionType)
    );
  }

  /**
   * @param request undefined
   */
  reportExportUpdateReportSubscriptionTypeResponse(
    request: UpdateReportSubscriptioinType
  ): __Observable<__StrictHttpResponse<ReportSubscriptionType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportSubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionType>;
      })
    );
  }
  /**
   * @param request undefined
   */
  reportExportUpdateReportSubscriptionType(
    request: UpdateReportSubscriptioinType
  ): __Observable<ReportSubscriptionType> {
    return this.reportExportUpdateReportSubscriptionTypeResponse(request).pipe(
      __map((_r) => _r.body as ReportSubscriptionType)
    );
  }

  /**
   * @param reportSubscriptionTypeId undefined
   */
  reportExportDeleteReportSubscriptionTypeResponse(
    reportSubscriptionTypeId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        reportSubscriptionTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportSubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param reportSubscriptionTypeId undefined
   */
  reportExportDeleteReportSubscriptionType(
    reportSubscriptionTypeId?: number
  ): __Observable<Blob> {
    return this.reportExportDeleteReportSubscriptionTypeResponse(
      reportSubscriptionTypeId
    ).pipe(__map((_r) => _r.body as Blob));
  }
  reportExportGetReportSubscriptionTypesResponse(): __Observable<
    __StrictHttpResponse<Array<ReportSubscriptionType>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportSubscriptionTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionType>>;
      })
    );
  }
  reportExportGetReportSubscriptionTypes(): __Observable<
    Array<ReportSubscriptionType>
  > {
    return this.reportExportGetReportSubscriptionTypesResponse().pipe(
      __map((_r) => _r.body as Array<ReportSubscriptionType>)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportGetReportSubscriptionContentParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportStandardTypeId`:
   *
   * - `reportEmbeddedTypeId`:
   */
  reportExportGetReportSubscriptionContentResponse(
    params: ReportExportService.ReportExportGetReportSubscriptionContentParams
  ): __Observable<__StrictHttpResponse<ReportSubscriptionContent>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.reportStandardTypeId != null)
      __params = __params.set(
        "reportStandardTypeId",
        params.reportStandardTypeId.toString()
      );
    if (params.reportEmbeddedTypeId != null)
      __params = __params.set(
        "reportEmbeddedTypeId",
        params.reportEmbeddedTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportSubscriptionContent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionContent>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportGetReportSubscriptionContentParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportStandardTypeId`:
   *
   * - `reportEmbeddedTypeId`:
   */
  reportExportGetReportSubscriptionContent(
    params: ReportExportService.ReportExportGetReportSubscriptionContentParams
  ): __Observable<ReportSubscriptionContent> {
    return this.reportExportGetReportSubscriptionContentResponse(params).pipe(
      __map((_r) => _r.body as ReportSubscriptionContent)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportDeleteReportSubscriptionContentParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionContentId`:
   */
  reportExportDeleteReportSubscriptionContentResponse(
    params: ReportExportService.ReportExportDeleteReportSubscriptionContentParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.reportSubscriptionContentId != null)
      __params = __params.set(
        "reportSubscriptionContentId",
        params.reportSubscriptionContentId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportSubscriptionContent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportDeleteReportSubscriptionContentParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionContentId`:
   */
  reportExportDeleteReportSubscriptionContent(
    params: ReportExportService.ReportExportDeleteReportSubscriptionContentParams
  ): __Observable<Blob> {
    return this.reportExportDeleteReportSubscriptionContentResponse(
      params
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param subscriptionTypeId undefined
   */
  reportExportGetReportSubscriptionContentsBySubscriptionTypeResponse(
    subscriptionTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportSubscriptionContent>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionTypeId != null)
      __params = __params.set(
        "subscriptionTypeId",
        subscriptionTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/ReportExport/GetReportSubscriptionContentsBySubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionContent>>;
      })
    );
  }
  /**
   * @param subscriptionTypeId undefined
   */
  reportExportGetReportSubscriptionContentsBySubscriptionType(
    subscriptionTypeId?: number
  ): __Observable<Array<ReportSubscriptionContent>> {
    return this.reportExportGetReportSubscriptionContentsBySubscriptionTypeResponse(
      subscriptionTypeId
    ).pipe(__map((_r) => _r.body as Array<ReportSubscriptionContent>));
  }
  reportExportGetReportSubscriptionContentsResponse(): __Observable<
    __StrictHttpResponse<Array<ReportSubscriptionContent>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportSubscriptionContents`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionContent>>;
      })
    );
  }
  reportExportGetReportSubscriptionContents(): __Observable<
    Array<ReportSubscriptionContent>
  > {
    return this.reportExportGetReportSubscriptionContentsResponse().pipe(
      __map((_r) => _r.body as Array<ReportSubscriptionContent>)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportSubscriptionLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `maxReportUsers`:
   *
   * - `maxAdminUsers`:
   *
   * - `description`:
   *
   * - `allowInvoice`:
   */
  reportExportCreateReportSubscriptionLevelResponse(
    params: ReportExportService.ReportExportCreateReportSubscriptionLevelParams
  ): __Observable<__StrictHttpResponse<ReportSubscriptionLevel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.maxReportUsers != null)
      __params = __params.set(
        "maxReportUsers",
        params.maxReportUsers.toString()
      );
    if (params.maxAdminUsers != null)
      __params = __params.set("maxAdminUsers", params.maxAdminUsers.toString());
    if (params.description != null)
      __params = __params.set("description", params.description.toString());
    if (params.allowInvoice != null)
      __params = __params.set("allowInvoice", params.allowInvoice.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionLevel>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportSubscriptionLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `maxReportUsers`:
   *
   * - `maxAdminUsers`:
   *
   * - `description`:
   *
   * - `allowInvoice`:
   */
  reportExportCreateReportSubscriptionLevel(
    params: ReportExportService.ReportExportCreateReportSubscriptionLevelParams
  ): __Observable<ReportSubscriptionLevel> {
    return this.reportExportCreateReportSubscriptionLevelResponse(params).pipe(
      __map((_r) => _r.body as ReportSubscriptionLevel)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportSubscriptionLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   *
   * - `maxReportUsers`:
   *
   * - `maxAdminUsers`:
   *
   * - `description`:
   *
   * - `allowInvoice`:
   */
  reportExportUpdateReportSubscriptionLevelResponse(
    params: ReportExportService.ReportExportUpdateReportSubscriptionLevelParams
  ): __Observable<__StrictHttpResponse<ReportSubscriptionLevel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.reportSubscriptionLevelId != null)
      __params = __params.set(
        "reportSubscriptionLevelId",
        params.reportSubscriptionLevelId.toString()
      );
    if (params.maxReportUsers != null)
      __params = __params.set(
        "maxReportUsers",
        params.maxReportUsers.toString()
      );
    if (params.maxAdminUsers != null)
      __params = __params.set("maxAdminUsers", params.maxAdminUsers.toString());
    if (params.description != null)
      __params = __params.set("description", params.description.toString());
    if (params.allowInvoice != null)
      __params = __params.set("allowInvoice", params.allowInvoice.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionLevel>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportSubscriptionLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   *
   * - `maxReportUsers`:
   *
   * - `maxAdminUsers`:
   *
   * - `description`:
   *
   * - `allowInvoice`:
   */
  reportExportUpdateReportSubscriptionLevel(
    params: ReportExportService.ReportExportUpdateReportSubscriptionLevelParams
  ): __Observable<ReportSubscriptionLevel> {
    return this.reportExportUpdateReportSubscriptionLevelResponse(params).pipe(
      __map((_r) => _r.body as ReportSubscriptionLevel)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportDeleteReportSubscriptionLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   */
  reportExportDeleteReportSubscriptionLevelResponse(
    params: ReportExportService.ReportExportDeleteReportSubscriptionLevelParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.reportSubscriptionLevelId != null)
      __params = __params.set(
        "reportSubscriptionLevelId",
        params.reportSubscriptionLevelId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportDeleteReportSubscriptionLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   */
  reportExportDeleteReportSubscriptionLevel(
    params: ReportExportService.ReportExportDeleteReportSubscriptionLevelParams
  ): __Observable<Blob> {
    return this.reportExportDeleteReportSubscriptionLevelResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param subscriptionTypeId undefined
   */
  reportExportGetReportSubscriptionLevelsBySubscriptionTypeResponse(
    subscriptionTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportSubscriptionLevelEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionTypeId != null)
      __params = __params.set(
        "subscriptionTypeId",
        subscriptionTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/ReportExport/GetReportSubscriptionLevelsBySubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionLevelEx>>;
      })
    );
  }
  /**
   * @param subscriptionTypeId undefined
   */
  reportExportGetReportSubscriptionLevelsBySubscriptionType(
    subscriptionTypeId?: number
  ): __Observable<Array<ReportSubscriptionLevelEx>> {
    return this.reportExportGetReportSubscriptionLevelsBySubscriptionTypeResponse(
      subscriptionTypeId
    ).pipe(__map((_r) => _r.body as Array<ReportSubscriptionLevelEx>));
  }
  reportExportGetReportSubscriptionLevelsResponse(): __Observable<
    __StrictHttpResponse<Array<ReportSubscriptionLevelEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportSubscriptionLevels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionLevelEx>>;
      })
    );
  }
  reportExportGetReportSubscriptionLevels(): __Observable<
    Array<ReportSubscriptionLevelEx>
  > {
    return this.reportExportGetReportSubscriptionLevelsResponse().pipe(
      __map((_r) => _r.body as Array<ReportSubscriptionLevelEx>)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportSubscriptionPriceParams` containing the following parameters:
   *
   * - `reportSubscriptionPrice.TaxRate`:
   *
   * - `reportSubscriptionPrice.SuppressInvoice`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionTypeId`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionLevelId`:
   *
   * - `reportSubscriptionPrice.ProposalId`:
   *
   * - `reportSubscriptionPrice.Price`:
   *
   * - `reportSubscriptionPrice.PeriodTypeId`:
   *
   * - `reportSubscriptionPrice.CustomTerms`:
   *
   * - `proposalFileUpload`:
   *
   * - `clearProposal`:
   */
  reportExportCreateReportSubscriptionPriceResponse(
    params: ReportExportService.ReportExportCreateReportSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<ReportSubscriptionPrice>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.reportSubscriptionPriceTaxRate != null) {
      __formData.append(
        "reportSubscriptionPrice.TaxRate",
        JSON.stringify(params.reportSubscriptionPriceTaxRate)
      );
    }
    if (params.reportSubscriptionPriceSuppressInvoice != null) {
      __formData.append(
        "reportSubscriptionPrice.SuppressInvoice",
        JSON.stringify(params.reportSubscriptionPriceSuppressInvoice)
      );
    }
    if (params.reportSubscriptionPriceReportSubscriptionTypeId != null) {
      __formData.append(
        "reportSubscriptionPrice.ReportSubscriptionTypeId",
        JSON.stringify(params.reportSubscriptionPriceReportSubscriptionTypeId)
      );
    }
    if (params.reportSubscriptionPriceReportSubscriptionLevelId != null) {
      __formData.append(
        "reportSubscriptionPrice.ReportSubscriptionLevelId",
        JSON.stringify(params.reportSubscriptionPriceReportSubscriptionLevelId)
      );
    }
    if (params.reportSubscriptionPriceProposalId != null) {
      __formData.append(
        "reportSubscriptionPrice.ProposalId",
        params.reportSubscriptionPriceProposalId as string | Blob
      );
    }
    if (params.reportSubscriptionPricePrice != null) {
      __formData.append(
        "reportSubscriptionPrice.Price",
        JSON.stringify(params.reportSubscriptionPricePrice)
      );
    }
    if (params.reportSubscriptionPricePeriodTypeId != null) {
      __formData.append(
        "reportSubscriptionPrice.PeriodTypeId",
        JSON.stringify(params.reportSubscriptionPricePeriodTypeId)
      );
    }
    if (params.reportSubscriptionPriceCustomTerms != null) {
      __formData.append(
        "reportSubscriptionPrice.CustomTerms",
        params.reportSubscriptionPriceCustomTerms as string | Blob
      );
    }
    if (params.proposalFileUpload != null) {
      __formData.append(
        "proposalFileUpload",
        params.proposalFileUpload as string | Blob
      );
    }
    if (params.clearProposal != null) {
      __formData.append("clearProposal", JSON.stringify(params.clearProposal));
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionPrice>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportSubscriptionPriceParams` containing the following parameters:
   *
   * - `reportSubscriptionPrice.TaxRate`:
   *
   * - `reportSubscriptionPrice.SuppressInvoice`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionTypeId`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionLevelId`:
   *
   * - `reportSubscriptionPrice.ProposalId`:
   *
   * - `reportSubscriptionPrice.Price`:
   *
   * - `reportSubscriptionPrice.PeriodTypeId`:
   *
   * - `reportSubscriptionPrice.CustomTerms`:
   *
   * - `proposalFileUpload`:
   *
   * - `clearProposal`:
   */
  reportExportCreateReportSubscriptionPrice(
    params: ReportExportService.ReportExportCreateReportSubscriptionPriceParams
  ): __Observable<ReportSubscriptionPrice> {
    return this.reportExportCreateReportSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as ReportSubscriptionPrice)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportSubscriptionPriceParams` containing the following parameters:
   *
   * - `reportSubscriptionPrice.TaxRate`:
   *
   * - `reportSubscriptionPrice.SuppressInvoice`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionTypeId`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionLevelId`:
   *
   * - `reportSubscriptionPrice.ProposalId`:
   *
   * - `reportSubscriptionPrice.Price`:
   *
   * - `reportSubscriptionPrice.PeriodTypeId`:
   *
   * - `reportSubscriptionPrice.CustomTerms`:
   *
   * - `proposalFileUpload`:
   *
   * - `clearProposal`:
   */
  reportExportUpdateReportSubscriptionPriceResponse(
    params: ReportExportService.ReportExportUpdateReportSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<ReportSubscriptionPrice>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.reportSubscriptionPriceTaxRate != null) {
      __formData.append(
        "reportSubscriptionPrice.TaxRate",
        JSON.stringify(params.reportSubscriptionPriceTaxRate)
      );
    }
    if (params.reportSubscriptionPriceSuppressInvoice != null) {
      __formData.append(
        "reportSubscriptionPrice.SuppressInvoice",
        JSON.stringify(params.reportSubscriptionPriceSuppressInvoice)
      );
    }
    if (params.reportSubscriptionPriceReportSubscriptionTypeId != null) {
      __formData.append(
        "reportSubscriptionPrice.ReportSubscriptionTypeId",
        JSON.stringify(params.reportSubscriptionPriceReportSubscriptionTypeId)
      );
    }
    if (params.reportSubscriptionPriceReportSubscriptionLevelId != null) {
      __formData.append(
        "reportSubscriptionPrice.ReportSubscriptionLevelId",
        JSON.stringify(params.reportSubscriptionPriceReportSubscriptionLevelId)
      );
    }
    if (params.reportSubscriptionPriceProposalId != null) {
      __formData.append(
        "reportSubscriptionPrice.ProposalId",
        params.reportSubscriptionPriceProposalId as string | Blob
      );
    }
    if (params.reportSubscriptionPricePrice != null) {
      __formData.append(
        "reportSubscriptionPrice.Price",
        JSON.stringify(params.reportSubscriptionPricePrice)
      );
    }
    if (params.reportSubscriptionPricePeriodTypeId != null) {
      __formData.append(
        "reportSubscriptionPrice.PeriodTypeId",
        JSON.stringify(params.reportSubscriptionPricePeriodTypeId)
      );
    }
    if (params.reportSubscriptionPriceCustomTerms != null) {
      __formData.append(
        "reportSubscriptionPrice.CustomTerms",
        params.reportSubscriptionPriceCustomTerms as string | Blob
      );
    }
    if (params.proposalFileUpload != null) {
      __formData.append(
        "proposalFileUpload",
        params.proposalFileUpload as string | Blob
      );
    }
    if (params.clearProposal != null) {
      __formData.append("clearProposal", JSON.stringify(params.clearProposal));
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportSubscriptionPrice>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportSubscriptionPriceParams` containing the following parameters:
   *
   * - `reportSubscriptionPrice.TaxRate`:
   *
   * - `reportSubscriptionPrice.SuppressInvoice`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionTypeId`:
   *
   * - `reportSubscriptionPrice.ReportSubscriptionLevelId`:
   *
   * - `reportSubscriptionPrice.ProposalId`:
   *
   * - `reportSubscriptionPrice.Price`:
   *
   * - `reportSubscriptionPrice.PeriodTypeId`:
   *
   * - `reportSubscriptionPrice.CustomTerms`:
   *
   * - `proposalFileUpload`:
   *
   * - `clearProposal`:
   */
  reportExportUpdateReportSubscriptionPrice(
    params: ReportExportService.ReportExportUpdateReportSubscriptionPriceParams
  ): __Observable<ReportSubscriptionPrice> {
    return this.reportExportUpdateReportSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as ReportSubscriptionPrice)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportDeleteReportSubscriptionPriceParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   *
   * - `periodTypeId`:
   */
  reportExportDeleteReportSubscriptionPriceResponse(
    params: ReportExportService.ReportExportDeleteReportSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.reportSubscriptionLevelId != null)
      __params = __params.set(
        "reportSubscriptionLevelId",
        params.reportSubscriptionLevelId.toString()
      );
    if (params.periodTypeId != null)
      __params = __params.set("periodTypeId", params.periodTypeId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportDeleteReportSubscriptionPriceParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   *
   * - `periodTypeId`:
   */
  reportExportDeleteReportSubscriptionPrice(
    params: ReportExportService.ReportExportDeleteReportSubscriptionPriceParams
  ): __Observable<Blob> {
    return this.reportExportDeleteReportSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportGetReportSubscriptionPricesByReportTypeAndLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   */
  reportExportGetReportSubscriptionPricesByReportTypeAndLevelResponse(
    params: ReportExportService.ReportExportGetReportSubscriptionPricesByReportTypeAndLevelParams
  ): __Observable<__StrictHttpResponse<Array<ReportSubscriptionPriceEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        params.reportSubscriptionTypeId.toString()
      );
    if (params.reportSubscriptionLevelId != null)
      __params = __params.set(
        "reportSubscriptionLevelId",
        params.reportSubscriptionLevelId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/ReportExport/GetReportSubscriptionPricesByReportTypeAndLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionPriceEx>>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportGetReportSubscriptionPricesByReportTypeAndLevelParams` containing the following parameters:
   *
   * - `reportSubscriptionTypeId`:
   *
   * - `reportSubscriptionLevelId`:
   */
  reportExportGetReportSubscriptionPricesByReportTypeAndLevel(
    params: ReportExportService.ReportExportGetReportSubscriptionPricesByReportTypeAndLevelParams
  ): __Observable<Array<ReportSubscriptionPriceEx>> {
    return this.reportExportGetReportSubscriptionPricesByReportTypeAndLevelResponse(
      params
    ).pipe(__map((_r) => _r.body as Array<ReportSubscriptionPriceEx>));
  }

  /**
   * @param reportSubscriptionTypeId undefined
   */
  reportExportGetReportSubscriptionPricesByReportTypeResponse(
    reportSubscriptionTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportSubscriptionPriceEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportSubscriptionTypeId != null)
      __params = __params.set(
        "reportSubscriptionTypeId",
        reportSubscriptionTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/ReportExport/GetReportSubscriptionPricesByReportType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionPriceEx>>;
      })
    );
  }
  /**
   * @param reportSubscriptionTypeId undefined
   */
  reportExportGetReportSubscriptionPricesByReportType(
    reportSubscriptionTypeId?: number
  ): __Observable<Array<ReportSubscriptionPriceEx>> {
    return this.reportExportGetReportSubscriptionPricesByReportTypeResponse(
      reportSubscriptionTypeId
    ).pipe(__map((_r) => _r.body as Array<ReportSubscriptionPriceEx>));
  }
  reportExportGetReportSubscriptionPricesResponse(): __Observable<
    __StrictHttpResponse<Array<ReportSubscriptionPriceEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportSubscriptionPrices`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportSubscriptionPriceEx>>;
      })
    );
  }
  reportExportGetReportSubscriptionPrices(): __Observable<
    Array<ReportSubscriptionPriceEx>
  > {
    return this.reportExportGetReportSubscriptionPricesResponse().pipe(
      __map((_r) => _r.body as Array<ReportSubscriptionPriceEx>)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportStandardLayoutParams` containing the following parameters:
   *
   * - `reportStandardLayout.UserId`:
   *
   * - `reportStandardLayout.SubscriptionId`:
   *
   * - `reportStandardLayout.ReportStandardTypeId`:
   *
   * - `reportStandardLayout.ReportStandardLayoutId`:
   *
   * - `reportStandardLayout.PreFilterId`:
   *
   * - `reportStandardLayout.OrderedPages`:
   *
   * - `reportStandardLayout.Name`:
   *
   * - `reportStandardLayout.HeaderFileId`:
   *
   * - `reportStandardLayout.FooterFileId`:
   *
   * - `reportStandardLayout.FilterData`:
   *
   * - `reportStandardLayout.BackgroundColor`:
   *
   * - `headerFileUpload`:
   *
   * - `footerFileUpload`:
   *
   * - `clearHeaderFile`:
   *
   * - `clearFooterFile`:
   */
  reportExportCreateReportStandardLayoutResponse(
    params: ReportExportService.ReportExportCreateReportStandardLayoutParams
  ): __Observable<__StrictHttpResponse<ReportStandardLayoutEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.reportStandardLayoutUserId != null) {
      __formData.append(
        "reportStandardLayout.UserId",
        JSON.stringify(params.reportStandardLayoutUserId)
      );
    }
    if (params.reportStandardLayoutSubscriptionId != null) {
      __formData.append(
        "reportStandardLayout.SubscriptionId",
        JSON.stringify(params.reportStandardLayoutSubscriptionId)
      );
    }
    if (params.reportStandardLayoutReportStandardTypeId != null) {
      __formData.append(
        "reportStandardLayout.ReportStandardTypeId",
        JSON.stringify(params.reportStandardLayoutReportStandardTypeId)
      );
    }
    if (params.reportStandardLayoutReportStandardLayoutId != null) {
      __formData.append(
        "reportStandardLayout.ReportStandardLayoutId",
        JSON.stringify(params.reportStandardLayoutReportStandardLayoutId)
      );
    }
    if (params.reportStandardLayoutPreFilterId != null) {
      __formData.append(
        "reportStandardLayout.PreFilterId",
        JSON.stringify(params.reportStandardLayoutPreFilterId)
      );
    }
    if (params.reportStandardLayoutOrderedPages != null) {
      __formData.append(
        "reportStandardLayout.OrderedPages",
        params.reportStandardLayoutOrderedPages as string | Blob
      );
    }
    if (params.reportStandardLayoutName != null) {
      __formData.append(
        "reportStandardLayout.Name",
        params.reportStandardLayoutName as string | Blob
      );
    }
    if (params.reportStandardLayoutHeaderFileId != null) {
      __formData.append(
        "reportStandardLayout.HeaderFileId",
        params.reportStandardLayoutHeaderFileId as string | Blob
      );
    }
    if (params.reportStandardLayoutFooterFileId != null) {
      __formData.append(
        "reportStandardLayout.FooterFileId",
        params.reportStandardLayoutFooterFileId as string | Blob
      );
    }
    if (params.reportStandardLayoutFilterData != null) {
      __formData.append(
        "reportStandardLayout.FilterData",
        params.reportStandardLayoutFilterData as string | Blob
      );
    }
    if (params.reportStandardLayoutBackgroundColor != null) {
      __formData.append(
        "reportStandardLayout.BackgroundColor",
        params.reportStandardLayoutBackgroundColor as string | Blob
      );
    }
    if (params.headerFileUpload != null) {
      __formData.append(
        "headerFileUpload",
        params.headerFileUpload as string | Blob
      );
    }
    if (params.footerFileUpload != null) {
      __formData.append(
        "footerFileUpload",
        params.footerFileUpload as string | Blob
      );
    }
    if (params.clearHeaderFile != null) {
      __formData.append(
        "clearHeaderFile",
        JSON.stringify(params.clearHeaderFile)
      );
    }
    if (params.clearFooterFile != null) {
      __formData.append(
        "clearFooterFile",
        JSON.stringify(params.clearFooterFile)
      );
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportStandardLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportStandardLayoutEx>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportStandardLayoutParams` containing the following parameters:
   *
   * - `reportStandardLayout.UserId`:
   *
   * - `reportStandardLayout.SubscriptionId`:
   *
   * - `reportStandardLayout.ReportStandardTypeId`:
   *
   * - `reportStandardLayout.ReportStandardLayoutId`:
   *
   * - `reportStandardLayout.PreFilterId`:
   *
   * - `reportStandardLayout.OrderedPages`:
   *
   * - `reportStandardLayout.Name`:
   *
   * - `reportStandardLayout.HeaderFileId`:
   *
   * - `reportStandardLayout.FooterFileId`:
   *
   * - `reportStandardLayout.FilterData`:
   *
   * - `reportStandardLayout.BackgroundColor`:
   *
   * - `headerFileUpload`:
   *
   * - `footerFileUpload`:
   *
   * - `clearHeaderFile`:
   *
   * - `clearFooterFile`:
   */
  reportExportCreateReportStandardLayout(
    params: ReportExportService.ReportExportCreateReportStandardLayoutParams
  ): __Observable<ReportStandardLayoutEx> {
    return this.reportExportCreateReportStandardLayoutResponse(params).pipe(
      __map((_r) => _r.body as ReportStandardLayoutEx)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportStandardLayoutParams` containing the following parameters:
   *
   * - `reportStandardLayout.UserId`:
   *
   * - `reportStandardLayout.SubscriptionId`:
   *
   * - `reportStandardLayout.ReportStandardTypeId`:
   *
   * - `reportStandardLayout.ReportStandardLayoutId`:
   *
   * - `reportStandardLayout.PreFilterId`:
   *
   * - `reportStandardLayout.OrderedPages`:
   *
   * - `reportStandardLayout.Name`:
   *
   * - `reportStandardLayout.HeaderFileId`:
   *
   * - `reportStandardLayout.FooterFileId`:
   *
   * - `reportStandardLayout.FilterData`:
   *
   * - `reportStandardLayout.BackgroundColor`:
   *
   * - `headerFileUpload`:
   *
   * - `footerFileUpload`:
   *
   * - `clearHeaderFile`:
   *
   * - `clearFooterFile`:
   */
  reportExportUpdateReportStandardLayoutResponse(
    params: ReportExportService.ReportExportUpdateReportStandardLayoutParams
  ): __Observable<__StrictHttpResponse<ReportStandardLayoutEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.reportStandardLayoutUserId != null) {
      __formData.append(
        "reportStandardLayout.UserId",
        JSON.stringify(params.reportStandardLayoutUserId)
      );
    }
    if (params.reportStandardLayoutSubscriptionId != null) {
      __formData.append(
        "reportStandardLayout.SubscriptionId",
        JSON.stringify(params.reportStandardLayoutSubscriptionId)
      );
    }
    if (params.reportStandardLayoutReportStandardTypeId != null) {
      __formData.append(
        "reportStandardLayout.ReportStandardTypeId",
        JSON.stringify(params.reportStandardLayoutReportStandardTypeId)
      );
    }
    if (params.reportStandardLayoutReportStandardLayoutId != null) {
      __formData.append(
        "reportStandardLayout.ReportStandardLayoutId",
        JSON.stringify(params.reportStandardLayoutReportStandardLayoutId)
      );
    }
    if (params.reportStandardLayoutPreFilterId != null) {
      __formData.append(
        "reportStandardLayout.PreFilterId",
        JSON.stringify(params.reportStandardLayoutPreFilterId)
      );
    }
    if (params.reportStandardLayoutOrderedPages != null) {
      __formData.append(
        "reportStandardLayout.OrderedPages",
        params.reportStandardLayoutOrderedPages as string | Blob
      );
    }
    if (params.reportStandardLayoutName != null) {
      __formData.append(
        "reportStandardLayout.Name",
        params.reportStandardLayoutName as string | Blob
      );
    }
    if (params.reportStandardLayoutHeaderFileId != null) {
      __formData.append(
        "reportStandardLayout.HeaderFileId",
        params.reportStandardLayoutHeaderFileId as string | Blob
      );
    }
    if (params.reportStandardLayoutFooterFileId != null) {
      __formData.append(
        "reportStandardLayout.FooterFileId",
        params.reportStandardLayoutFooterFileId as string | Blob
      );
    }
    if (params.reportStandardLayoutFilterData != null) {
      __formData.append(
        "reportStandardLayout.FilterData",
        params.reportStandardLayoutFilterData as string | Blob
      );
    }
    if (params.reportStandardLayoutBackgroundColor != null) {
      __formData.append(
        "reportStandardLayout.BackgroundColor",
        params.reportStandardLayoutBackgroundColor as string | Blob
      );
    }
    if (params.headerFileUpload != null) {
      __formData.append(
        "headerFileUpload",
        params.headerFileUpload as string | Blob
      );
    }
    if (params.footerFileUpload != null) {
      __formData.append(
        "footerFileUpload",
        params.footerFileUpload as string | Blob
      );
    }
    if (params.clearHeaderFile != null) {
      __formData.append(
        "clearHeaderFile",
        JSON.stringify(params.clearHeaderFile)
      );
    }
    if (params.clearFooterFile != null) {
      __formData.append(
        "clearFooterFile",
        JSON.stringify(params.clearFooterFile)
      );
    }
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportStandardLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportStandardLayoutEx>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportStandardLayoutParams` containing the following parameters:
   *
   * - `reportStandardLayout.UserId`:
   *
   * - `reportStandardLayout.SubscriptionId`:
   *
   * - `reportStandardLayout.ReportStandardTypeId`:
   *
   * - `reportStandardLayout.ReportStandardLayoutId`:
   *
   * - `reportStandardLayout.PreFilterId`:
   *
   * - `reportStandardLayout.OrderedPages`:
   *
   * - `reportStandardLayout.Name`:
   *
   * - `reportStandardLayout.HeaderFileId`:
   *
   * - `reportStandardLayout.FooterFileId`:
   *
   * - `reportStandardLayout.FilterData`:
   *
   * - `reportStandardLayout.BackgroundColor`:
   *
   * - `headerFileUpload`:
   *
   * - `footerFileUpload`:
   *
   * - `clearHeaderFile`:
   *
   * - `clearFooterFile`:
   */
  reportExportUpdateReportStandardLayout(
    params: ReportExportService.ReportExportUpdateReportStandardLayoutParams
  ): __Observable<ReportStandardLayoutEx> {
    return this.reportExportUpdateReportStandardLayoutResponse(params).pipe(
      __map((_r) => _r.body as ReportStandardLayoutEx)
    );
  }

  /**
   * @param reportStandardLayoutId undefined
   */
  reportExportDeleteReportStandardLayoutResponse(
    reportStandardLayoutId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportStandardLayoutId != null)
      __params = __params.set(
        "reportStandardLayoutId",
        reportStandardLayoutId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportStandardLayout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param reportStandardLayoutId undefined
   */
  reportExportDeleteReportStandardLayout(
    reportStandardLayoutId?: number
  ): __Observable<Blob> {
    return this.reportExportDeleteReportStandardLayoutResponse(
      reportStandardLayoutId
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param userId undefined
   */
  reportExportGetReportStandardLayoutsByUserResponse(
    userId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportStandardLayoutEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set("userId", userId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportStandardLayoutsByUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportStandardLayoutEx>>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  reportExportGetReportStandardLayoutsByUser(
    userId?: number
  ): __Observable<Array<ReportStandardLayoutEx>> {
    return this.reportExportGetReportStandardLayoutsByUserResponse(userId).pipe(
      __map((_r) => _r.body as Array<ReportStandardLayoutEx>)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  reportExportGetReportStandardLayoutsBySubscriptionResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportStandardLayoutEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportStandardLayoutsBySubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportStandardLayoutEx>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  reportExportGetReportStandardLayoutsBySubscription(
    subscriptionId?: number
  ): __Observable<Array<ReportStandardLayoutEx>> {
    return this.reportExportGetReportStandardLayoutsBySubscriptionResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as Array<ReportStandardLayoutEx>));
  }

  /**
   * @param reportStandardTypeId undefined
   */
  reportExportGetReportStandardLayoutsByReportStandardTypeResponse(
    reportStandardTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportStandardLayoutEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportStandardTypeId != null)
      __params = __params.set(
        "reportStandardTypeId",
        reportStandardTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/ReportExport/GetReportStandardLayoutsByReportStandardType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportStandardLayoutEx>>;
      })
    );
  }
  /**
   * @param reportStandardTypeId undefined
   */
  reportExportGetReportStandardLayoutsByReportStandardType(
    reportStandardTypeId?: number
  ): __Observable<Array<ReportStandardLayoutEx>> {
    return this.reportExportGetReportStandardLayoutsByReportStandardTypeResponse(
      reportStandardTypeId
    ).pipe(__map((_r) => _r.body as Array<ReportStandardLayoutEx>));
  }
  reportExportGetReportStandardLayoutsResponse(): __Observable<
    __StrictHttpResponse<Array<ReportStandardLayoutEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportStandardLayouts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportStandardLayoutEx>>;
      })
    );
  }
  reportExportGetReportStandardLayouts(): __Observable<
    Array<ReportStandardLayoutEx>
  > {
    return this.reportExportGetReportStandardLayoutsResponse().pipe(
      __map((_r) => _r.body as Array<ReportStandardLayoutEx>)
    );
  }

  /**
   * @param reportStandardLayoutId undefined
   */
  reportExportReportExportRequestResponse(
    reportStandardLayoutId?: number
  ): __Observable<__StrictHttpResponse<ReportExport>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportStandardLayoutId != null)
      __params = __params.set(
        "reportStandardLayoutId",
        reportStandardLayoutId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/ReportExportRequest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportExport>;
      })
    );
  }
  /**
   * @param reportStandardLayoutId undefined
   */
  reportExportReportExportRequest(
    reportStandardLayoutId?: number
  ): __Observable<ReportExport> {
    return this.reportExportReportExportRequestResponse(
      reportStandardLayoutId
    ).pipe(__map((_r) => _r.body as ReportExport));
  }

  /**
   * @param reportExportId undefined
   */
  reportExportReportExportDeleteResponse(
    reportExportId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportExportId != null)
      __params = __params.set("reportExportId", reportExportId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/ReportExportDelete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param reportExportId undefined
   */
  reportExportReportExportDelete(
    reportExportId?: number
  ): __Observable<boolean> {
    return this.reportExportReportExportDeleteResponse(reportExportId).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param reportExportId undefined
   */
  reportExportReportExportExtendResponse(
    reportExportId?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportExportId != null)
      __params = __params.set("reportExportId", reportExportId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/ReportExportExtend`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param reportExportId undefined
   */
  reportExportReportExportExtend(
    reportExportId?: number
  ): __Observable<string> {
    return this.reportExportReportExportExtendResponse(reportExportId).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportReportExportStatusUpdateParams` containing the following parameters:
   *
   * - `statusMessage`:
   *
   * - `status`:
   *
   * - `reportExportId`:
   *
   * - `fileId`:
   */
  reportExportReportExportStatusUpdateResponse(
    params: ReportExportService.ReportExportReportExportStatusUpdateParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.statusMessage != null)
      __params = __params.set("statusMessage", params.statusMessage.toString());
    if (params.status != null)
      __params = __params.set("status", params.status.toString());
    if (params.reportExportId != null)
      __params = __params.set(
        "reportExportId",
        params.reportExportId.toString()
      );
    if (params.fileId != null)
      __params = __params.set("fileId", params.fileId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/ReportExportStatusUpdate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportReportExportStatusUpdateParams` containing the following parameters:
   *
   * - `statusMessage`:
   *
   * - `status`:
   *
   * - `reportExportId`:
   *
   * - `fileId`:
   */
  reportExportReportExportStatusUpdate(
    params: ReportExportService.ReportExportReportExportStatusUpdateParams
  ): __Observable<Blob> {
    return this.reportExportReportExportStatusUpdateResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param userId undefined
   */
  reportExportGetReportExportsByUserResponse(
    userId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportExport>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set("userId", userId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportExportsByUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportExport>>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  reportExportGetReportExportsByUser(
    userId?: number
  ): __Observable<Array<ReportExport>> {
    return this.reportExportGetReportExportsByUserResponse(userId).pipe(
      __map((_r) => _r.body as Array<ReportExport>)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  reportExportGetReportExportsBySubscriptionResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportExport>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportExportsBySubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportExport>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  reportExportGetReportExportsBySubscription(
    subscriptionId?: number
  ): __Observable<Array<ReportExport>> {
    return this.reportExportGetReportExportsBySubscriptionResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as Array<ReportExport>));
  }

  /**
   * @param reportExportId undefined
   */
  reportExportGetReportExportByIdResponse(
    reportExportId?: number
  ): __Observable<__StrictHttpResponse<ReportExport>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportExportId != null)
      __params = __params.set("reportExportId", reportExportId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportExportById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportExport>;
      })
    );
  }
  /**
   * @param reportExportId undefined
   */
  reportExportGetReportExportById(
    reportExportId?: number
  ): __Observable<ReportExport> {
    return this.reportExportGetReportExportByIdResponse(reportExportId).pipe(
      __map((_r) => _r.body as ReportExport)
    );
  }

  /**
   * @param reportExportId undefined
   */
  reportExportGetReportExportDownloadUrlResponse(
    reportExportId?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportExportId != null)
      __params = __params.set("reportExportId", reportExportId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportExportDownloadUrl`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param reportExportId undefined
   */
  reportExportGetReportExportDownloadUrl(
    reportExportId?: number
  ): __Observable<string> {
    return this.reportExportGetReportExportDownloadUrlResponse(
      reportExportId
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param params The `ReportExportService.ReportExportCreateReportEmbeddedExportParams` containing the following parameters:
   *
   * - `editData`:
   *
   * - `reportEmbeddedTypeId`:
   */
  reportExportCreateReportEmbeddedExportResponse(
    params: ReportExportService.ReportExportCreateReportEmbeddedExportParams
  ): __Observable<__StrictHttpResponse<ReportEmbeddedExport>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.editData;
    if (params.reportEmbeddedTypeId != null)
      __params = __params.set(
        "reportEmbeddedTypeId",
        params.reportEmbeddedTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/CreateReportEmbeddedExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportEmbeddedExport>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportCreateReportEmbeddedExportParams` containing the following parameters:
   *
   * - `editData`:
   *
   * - `reportEmbeddedTypeId`:
   */
  reportExportCreateReportEmbeddedExport(
    params: ReportExportService.ReportExportCreateReportEmbeddedExportParams
  ): __Observable<ReportEmbeddedExport> {
    return this.reportExportCreateReportEmbeddedExportResponse(params).pipe(
      __map((_r) => _r.body as ReportEmbeddedExport)
    );
  }

  /**
   * @param params The `ReportExportService.ReportExportUpdateReportEmbeddedExportParams` containing the following parameters:
   *
   * - `editData`:
   *
   * - `reportEmbeddedExportId`:
   */
  reportExportUpdateReportEmbeddedExportResponse(
    params: ReportExportService.ReportExportUpdateReportEmbeddedExportParams
  ): __Observable<__StrictHttpResponse<ReportEmbeddedExport>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.editData;
    if (params.reportEmbeddedExportId != null)
      __params = __params.set(
        "reportEmbeddedExportId",
        params.reportEmbeddedExportId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/UpdateReportEmbeddedExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportEmbeddedExport>;
      })
    );
  }
  /**
   * @param params The `ReportExportService.ReportExportUpdateReportEmbeddedExportParams` containing the following parameters:
   *
   * - `editData`:
   *
   * - `reportEmbeddedExportId`:
   */
  reportExportUpdateReportEmbeddedExport(
    params: ReportExportService.ReportExportUpdateReportEmbeddedExportParams
  ): __Observable<ReportEmbeddedExport> {
    return this.reportExportUpdateReportEmbeddedExportResponse(params).pipe(
      __map((_r) => _r.body as ReportEmbeddedExport)
    );
  }

  /**
   * @param userId undefined
   */
  reportExportGetReportEmbeddedExportsByUserIdResponse(
    userId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportEmbeddedExport>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set("userId", userId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetReportEmbeddedExportsByUserId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportEmbeddedExport>>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  reportExportGetReportEmbeddedExportsByUserId(
    userId?: number
  ): __Observable<Array<ReportEmbeddedExport>> {
    return this.reportExportGetReportEmbeddedExportsByUserIdResponse(
      userId
    ).pipe(__map((_r) => _r.body as Array<ReportEmbeddedExport>));
  }

  /**
   * @param subscriptionId undefined
   */
  reportExportGetReportEmbeddedExportsBySubscriptionIdResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<ReportEmbeddedExport>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/ReportExport/GetReportEmbeddedExportsBySubscriptionId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ReportEmbeddedExport>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  reportExportGetReportEmbeddedExportsBySubscriptionId(
    subscriptionId?: number
  ): __Observable<Array<ReportEmbeddedExport>> {
    return this.reportExportGetReportEmbeddedExportsBySubscriptionIdResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as Array<ReportEmbeddedExport>));
  }

  /**
   * @param reportEmbeddedExportId undefined
   */
  reportExportReportEmbeddedExportDeleteResponse(
    reportEmbeddedExportId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportEmbeddedExportId != null)
      __params = __params.set(
        "reportEmbeddedExportId",
        reportEmbeddedExportId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/DeleteReportEmbeddedExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param reportEmbeddedExportId undefined
   */
  reportExportReportEmbeddedExportDelete(
    reportEmbeddedExportId?: number
  ): __Observable<boolean> {
    return this.reportExportReportEmbeddedExportDeleteResponse(
      reportEmbeddedExportId
    ).pipe(__map((_r) => _r.body as boolean));
  }
  reportExportGetUserReportExportStateResponse(): __Observable<
    __StrictHttpResponse<ReportExportUserState>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetUserReportExportState`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportExportUserState>;
      })
    );
  }
  reportExportGetUserReportExportState(): __Observable<ReportExportUserState> {
    return this.reportExportGetUserReportExportStateResponse().pipe(
      __map((_r) => _r.body as ReportExportUserState)
    );
  }

  /**
   * @param userId undefined
   */
  reportExportGetUserReportExportStateByUserIdResponse(
    userId?: number
  ): __Observable<__StrictHttpResponse<ReportExportUserState>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set("userId", userId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetUserReportExportStateByUserId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReportExportUserState>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  reportExportGetUserReportExportStateByUserId(
    userId?: number
  ): __Observable<ReportExportUserState> {
    return this.reportExportGetUserReportExportStateByUserIdResponse(
      userId
    ).pipe(__map((_r) => _r.body as ReportExportUserState));
  }

  /**
   * @param embedId undefined
   */
  reportExportGetEmbedReportDetailsResponse(
    embedId?: string
  ): __Observable<__StrictHttpResponse<EmbedReportDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (embedId != null) __params = __params.set("embedId", embedId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetEmbedReportDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EmbedReportDetails>;
      })
    );
  }
  /**
   * @param embedId undefined
   */
  reportExportGetEmbedReportDetails(
    embedId?: string
  ): __Observable<EmbedReportDetails> {
    return this.reportExportGetEmbedReportDetailsResponse(embedId).pipe(
      __map((_r) => _r.body as EmbedReportDetails)
    );
  }

  /**
   * @param reportExportId undefined
   */
  reportExportGetStandardReportDetailsResponse(
    reportExportId?: number
  ): __Observable<__StrictHttpResponse<StandardReportDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportExportId != null)
      __params = __params.set("reportExportId", reportExportId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/ReportExport/GetStandardReportDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StandardReportDetails>;
      })
    );
  }
  /**
   * @param reportExportId undefined
   */
  reportExportGetStandardReportDetails(
    reportExportId?: number
  ): __Observable<StandardReportDetails> {
    return this.reportExportGetStandardReportDetailsResponse(
      reportExportId
    ).pipe(__map((_r) => _r.body as StandardReportDetails));
  }

  /**
   * @param usageDetails undefined
   */
  reportExportLogWidgetUsageResponse(
    usageDetails: LogWidgetUsage
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = usageDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/LogWidgetUsage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param usageDetails undefined
   */
  reportExportLogWidgetUsage(usageDetails: LogWidgetUsage): __Observable<Blob> {
    return this.reportExportLogWidgetUsageResponse(usageDetails).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param usageDetails undefined
   */
  reportExportLogGatedWidgetUsageResponse(
    usageDetails: LogWidgetUsage
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = usageDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/ReportExport/LogGatedWidgetUsage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param usageDetails undefined
   */
  reportExportLogGatedWidgetUsage(
    usageDetails: LogWidgetUsage
  ): __Observable<Blob> {
    return this.reportExportLogGatedWidgetUsageResponse(usageDetails).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module ReportExportService {
  /**
   * Parameters for ReportExportCreateReportSource
   */
  export interface ReportExportCreateReportSourceParams {
    upload?: null | Blob;
    reportSourceReportSourceId?: number;
    reportSourcePreFilterTitleAvailable?: boolean;
    reportSourcePreFilterRegionAvailable?: boolean;
    reportSourcePreFilterOccupationAvailable?: boolean;
    reportSourcePreFilterIndustryAvailable?: boolean;
    reportSourcePreFilterCompanyAvailable?: boolean;
    reportSourcePowerBIObjectName?: null | string;
    reportSourceName?: null | string;
    reportSourceFileName?: null | string;
    reportSourceFileId?: null | string;
    reportSourceDescription?: null | string;
    reportSourceActive?: boolean;
    PreFilterTitleAvailable?: boolean;
    PreFilterRegionAvailable?: boolean;
    PreFilterOccupationAvailable?: boolean;
    PreFilterIndustryAvailable?: boolean;
    PreFilterCompanyAvailable?: boolean;
    Active?: boolean;
  }

  /**
   * Parameters for ReportExportUpdateReportSource
   */
  export interface ReportExportUpdateReportSourceParams {
    upload?: null | Blob;
    reportSourceReportSourceId?: number;
    reportSourcePreFilterTitleAvailable?: boolean;
    reportSourcePreFilterRegionAvailable?: boolean;
    reportSourcePreFilterOccupationAvailable?: boolean;
    reportSourcePreFilterIndustryAvailable?: boolean;
    reportSourcePreFilterCompanyAvailable?: boolean;
    reportSourcePowerBIObjectName?: null | string;
    reportSourceName?: null | string;
    reportSourceFileName?: null | string;
    reportSourceFileId?: null | string;
    reportSourceDescription?: null | string;
    reportSourceActive?: boolean;
    PreFilterTitleAvailable?: boolean;
    PreFilterRegionAvailable?: boolean;
    PreFilterOccupationAvailable?: boolean;
    PreFilterIndustryAvailable?: boolean;
    PreFilterCompanyAvailable?: boolean;
    Active?: boolean;
  }

  /**
   * Parameters for ReportExportCreateReportEmbeddedType
   */
  export interface ReportExportCreateReportEmbeddedTypeParams {
    reportSourceId?: number;
    reportPages?: null | string;
    name?: null | string;
    filterPage?: null | string;
  }

  /**
   * Parameters for ReportExportUpdateReportEmbeddedType
   */
  export interface ReportExportUpdateReportEmbeddedTypeParams {
    reportSourceId?: number;
    reportPages?: null | string;
    reportEmbeddedTypeId?: number;
    name?: null | string;
    filterPage?: null | string;
  }

  /**
   * Parameters for ReportExportCreateReportStandardType
   */
  export interface ReportExportCreateReportStandardTypeParams {
    reportSourceId?: number;
    reportPages?: null | string;
    name?: null | string;
    filterPage?: null | string;
  }

  /**
   * Parameters for ReportExportUpdateReportStandardType
   */
  export interface ReportExportUpdateReportStandardTypeParams {
    reportStandardTypeId?: number;
    reportSourceId?: number;
    reportPages?: null | string;
    name?: null | string;
    filterPage?: null | string;
  }

  /**
   * Parameters for ReportExportGetReportSubscriptionContent
   */
  export interface ReportExportGetReportSubscriptionContentParams {
    reportSubscriptionTypeId?: number;
    reportStandardTypeId?: null | number;
    reportEmbeddedTypeId?: null | number;
  }

  /**
   * Parameters for ReportExportDeleteReportSubscriptionContent
   */
  export interface ReportExportDeleteReportSubscriptionContentParams {
    reportSubscriptionTypeId?: number;
    reportSubscriptionContentId?: number;
  }

  /**
   * Parameters for ReportExportCreateReportSubscriptionLevel
   */
  export interface ReportExportCreateReportSubscriptionLevelParams {
    reportSubscriptionTypeId?: number;
    maxReportUsers?: number;
    maxAdminUsers?: number;
    description?: null | string;
    allowInvoice?: boolean;
  }

  /**
   * Parameters for ReportExportUpdateReportSubscriptionLevel
   */
  export interface ReportExportUpdateReportSubscriptionLevelParams {
    reportSubscriptionTypeId?: number;
    reportSubscriptionLevelId?: number;
    maxReportUsers?: number;
    maxAdminUsers?: number;
    description?: null | string;
    allowInvoice?: boolean;
  }

  /**
   * Parameters for ReportExportDeleteReportSubscriptionLevel
   */
  export interface ReportExportDeleteReportSubscriptionLevelParams {
    reportSubscriptionTypeId?: number;
    reportSubscriptionLevelId?: number;
  }

  /**
   * Parameters for ReportExportCreateReportSubscriptionPrice
   */
  export interface ReportExportCreateReportSubscriptionPriceParams {
    reportSubscriptionPriceTaxRate?: null | number;
    reportSubscriptionPriceSuppressInvoice?: boolean;
    reportSubscriptionPriceReportSubscriptionTypeId?: number;
    reportSubscriptionPriceReportSubscriptionLevelId?: number;
    reportSubscriptionPriceProposalId?: null | string;
    reportSubscriptionPricePrice?: null | number;
    reportSubscriptionPricePeriodTypeId?: number;
    reportSubscriptionPriceCustomTerms?: null | string;
    proposalFileUpload?: null | Blob;
    clearProposal?: boolean;
  }

  /**
   * Parameters for ReportExportUpdateReportSubscriptionPrice
   */
  export interface ReportExportUpdateReportSubscriptionPriceParams {
    reportSubscriptionPriceTaxRate?: null | number;
    reportSubscriptionPriceSuppressInvoice?: boolean;
    reportSubscriptionPriceReportSubscriptionTypeId?: number;
    reportSubscriptionPriceReportSubscriptionLevelId?: number;
    reportSubscriptionPriceProposalId?: null | string;
    reportSubscriptionPricePrice?: null | number;
    reportSubscriptionPricePeriodTypeId?: number;
    reportSubscriptionPriceCustomTerms?: null | string;
    proposalFileUpload?: null | Blob;
    clearProposal?: boolean;
  }

  /**
   * Parameters for ReportExportDeleteReportSubscriptionPrice
   */
  export interface ReportExportDeleteReportSubscriptionPriceParams {
    reportSubscriptionTypeId?: number;
    reportSubscriptionLevelId?: number;
    periodTypeId?: number;
  }

  /**
   * Parameters for ReportExportGetReportSubscriptionPricesByReportTypeAndLevel
   */
  export interface ReportExportGetReportSubscriptionPricesByReportTypeAndLevelParams {
    reportSubscriptionTypeId?: number;
    reportSubscriptionLevelId?: number;
  }

  /**
   * Parameters for ReportExportCreateReportStandardLayout
   */
  export interface ReportExportCreateReportStandardLayoutParams {
    reportStandardLayoutUserId?: number;
    reportStandardLayoutSubscriptionId?: number;
    reportStandardLayoutReportStandardTypeId?: number;
    reportStandardLayoutReportStandardLayoutId?: number;
    reportStandardLayoutPreFilterId?: null | number;
    reportStandardLayoutOrderedPages?: null | string;
    reportStandardLayoutName?: null | string;
    reportStandardLayoutHeaderFileId?: null | string;
    reportStandardLayoutFooterFileId?: null | string;
    reportStandardLayoutFilterData?: null | string;
    reportStandardLayoutBackgroundColor?: null | string;
    headerFileUpload?: null | Blob;
    footerFileUpload?: null | Blob;
    clearHeaderFile?: boolean;
    clearFooterFile?: boolean;
  }

  /**
   * Parameters for ReportExportUpdateReportStandardLayout
   */
  export interface ReportExportUpdateReportStandardLayoutParams {
    reportStandardLayoutUserId?: number;
    reportStandardLayoutSubscriptionId?: number;
    reportStandardLayoutReportStandardTypeId?: number;
    reportStandardLayoutReportStandardLayoutId?: number;
    reportStandardLayoutPreFilterId?: null | number;
    reportStandardLayoutOrderedPages?: null | string;
    reportStandardLayoutName?: null | string;
    reportStandardLayoutHeaderFileId?: null | string;
    reportStandardLayoutFooterFileId?: null | string;
    reportStandardLayoutFilterData?: null | string;
    reportStandardLayoutBackgroundColor?: null | string;
    headerFileUpload?: null | Blob;
    footerFileUpload?: null | Blob;
    clearHeaderFile?: boolean;
    clearFooterFile?: boolean;
  }

  /**
   * Parameters for ReportExportReportExportStatusUpdate
   */
  export interface ReportExportReportExportStatusUpdateParams {
    statusMessage?: null | string;
    status?: 0 | 1 | 2 | 3;
    reportExportId?: number;
    fileId?: null | string;
  }

  /**
   * Parameters for ReportExportCreateReportEmbeddedExport
   */
  export interface ReportExportCreateReportEmbeddedExportParams {
    editData: EditEmbeddedReportExportLayoutData;
    reportEmbeddedTypeId?: number;
  }

  /**
   * Parameters for ReportExportUpdateReportEmbeddedExport
   */
  export interface ReportExportUpdateReportEmbeddedExportParams {
    editData: EditEmbeddedReportExportLayoutData;
    reportEmbeddedExportId?: number;
  }
}

export { ReportExportService };
